import { subjects as integrationSubjects } from '@sopranodesign/pulse-integrations';
import { subjects as defaultSubjects } from '@sopranodesign/pulse-conditionals';
import { subjects as importSubjects } from '@sopranodesign/pulse-import';

import message from './Message/index';
import payment from './Payment/index';

const conditionals = [
  message,
  ...defaultSubjects.subjects,
  integrationSubjects.conditionals.integration,
  integrationSubjects.conditionals.lookup,
  integrationSubjects.conditionals.variable,
  importSubjects.conditionals.section,
  payment
];

export default conditionals;
